import { PAC_FORM_TYPES } from "social/constants";
import { SOCIAL_AD_TYPES } from "utils/constants";

const FACEBOOK_IMAGE_PAC_FIELDS = {
	[PAC_FORM_TYPES.SQUARE]: [
		"image",
		"headline",
		"primaryText",
		"landingPage",
		"displayLink",
	],
	[PAC_FORM_TYPES.VERTICAL]: [
		"image",
		"headline",
		"primaryText",
		"landingPage",
		"displayLink",
	],
	[PAC_FORM_TYPES.HORIZONTAL]: [
		"image",
		"headline",
		"primaryText",
		"landingPage",
		"displayLink",
	],
};

const FACEBOOK_IMAGE_MO_PAC_FIELDS = {
	[PAC_FORM_TYPES.SQUARE]: [
		"image",
		"headline",
		"primaryText",
		"landingPage",
		"displayLink",
	],
	[PAC_FORM_TYPES.VERTICAL]: [
		"image",
		"headline",
		"primaryText",
		"landingPage",
		"displayLink",
	],
	[PAC_FORM_TYPES.HORIZONTAL]: [
		"image",
		"headline",
		"primaryText",
		"landingPage",
		"displayLink",
	],
	[PAC_FORM_TYPES.REELS]: [
		"image",
		"primaryText",
		"landingPage",
	],
};

const FACEBOOK_VIDEO_PAC_FIELDS = {
	[PAC_FORM_TYPES.SQUARE]: [
		"video",
		"headline",
		"primaryText",
		"landingPage",
		"displayLink",
	],
	[PAC_FORM_TYPES.VERTICAL]: [
		"video",
		"headline",
		"primaryText",
		"landingPage",
		"displayLink",
	],
	[PAC_FORM_TYPES.HORIZONTAL]: [
		"video",
		"headline",
		"primaryText",
		"landingPage",
		"displayLink",
	],
};

const FACEBOOK_VIDEO_MO_PAC_FIELDS = {
	[PAC_FORM_TYPES.SQUARE]: [
		"video",
		"thumbnail",
		"headline",
		"primaryText",
		"landingPage",
		"displayLink",
	],
	[PAC_FORM_TYPES.VERTICAL]: [
		"video",
		"thumbnail",
		"headline",
		"primaryText",
		"landingPage",
		"displayLink",
	],
	[PAC_FORM_TYPES.HORIZONTAL]: [
		"video",
		"thumbnail",
		"headline",
		"primaryText",
		"landingPage",
		"displayLink",
	],
	[PAC_FORM_TYPES.REELS]: [
		"video",
		"thumbnail",
		"primaryText",
		"landingPage",
	],
};

export const PAC_FIELDS_BY_AD_TYPE = {
	[SOCIAL_AD_TYPES.FACEBOOK_IMAGE]: FACEBOOK_IMAGE_PAC_FIELDS,
	[SOCIAL_AD_TYPES.FACEBOOK_IMAGE_MO]: FACEBOOK_IMAGE_MO_PAC_FIELDS,
	[SOCIAL_AD_TYPES.FACEBOOK_VIDEO]: FACEBOOK_VIDEO_PAC_FIELDS,
	[SOCIAL_AD_TYPES.FACEBOOK_VIDEO_MO]: FACEBOOK_VIDEO_MO_PAC_FIELDS,
};

function defaultFieldGenerator(props) {
	return {
		showPristineErrors: !props.isNew && props.showPristineErrors,
	};
}

export const CUSTOM_FIELD_GENERATORS_BY_PLACEMENT_TYPE = {
	[PAC_FORM_TYPES.SQUARE]: defaultFieldGenerator,
	[PAC_FORM_TYPES.VERTICAL]: defaultFieldGenerator,
	[PAC_FORM_TYPES.HORIZONTAL]: defaultFieldGenerator,
	[PAC_FORM_TYPES.REELS]: defaultFieldGenerator,
};

export const PAC_SELECT_DISABLED_VERSIONS_MESSAGE = "Aspect ratios cannot be added or removed once the creative has versions";
